"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRACK_PAGE_TITLES = exports.TracksEndpointKeys = void 0;
var TracksEndpointKeys;
(function (TracksEndpointKeys) {
    TracksEndpointKeys["GetAll"] = "tracks.getAll";
    TracksEndpointKeys["GetById"] = "tracks.getById";
    TracksEndpointKeys["Create"] = "tracks.create";
    TracksEndpointKeys["Update"] = "tracks.update";
    TracksEndpointKeys["Delete"] = "tracks.delete";
    TracksEndpointKeys["GetContent"] = "tracks.getContent";
    TracksEndpointKeys["UpdateContent"] = "tracks.updateContent";
    TracksEndpointKeys["Publish"] = "tracks.publish";
    TracksEndpointKeys["Order"] = "tracks.order";
})(TracksEndpointKeys || (exports.TracksEndpointKeys = TracksEndpointKeys = {}));
exports.TRACK_PAGE_TITLES = {
    LIST: 'general.tracks',
    NEW: 'tracks.create.title',
    VIEW: 'general.track',
    EDIT: 'general.track'
};
